export default __webpack_public_path__ + "static/media/Image_BGLAWARDS_0623_BGL.0be17c05.png";